import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';
import { DropdownListItem } from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import { CONTAINER_HEIGHT } from '../styles/CommunicationHistoryTableContainer.styles';

const gridTemplateColumns = '5.56% 16.67% 27.78% 22.22% 22.22% 5.56%';
// const gridTemplateColumns = '1fr 3fr 5fr 4fr 4fr 1fr';
// TODO: convert to `fr`, reminder to check ellipsis of text
export const TOOLTIP_HEIGHT = 20;
export const TOOLTIP_CHILD_OFFSET = 4;

export const TableWrapper = styled(Box).attrs(({ theme }) => ({
  justify: 'start',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  height: CONTAINER_HEIGHT,
}))`
  overflow-x: hidden;
  overflow-y: auto;
`;

export const TableHeader = styled.div`
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns: ${gridTemplateColumns};
  align-items: center;
  z-index: 1;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.foreground};
  justify-content: flex-start;
`;

export const TableHeaderCell = styled(Box).attrs({
  justify: 'start',
  align: 'center',
  p: '5px',
  height: '100%',
  width: '100%',
  horizontal: true,
  color: 'primaryText',
})`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'unset')};
`;
export const TableData = styled(Box).attrs({
  justify: 'start',
  align: 'center',
  p: '5px',
  height: '100%',
  width: '100%',
  horizontal: true,
  backgroundColor: 'background',
  color: 'primaryText',
})`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'unset')};
`;

export const TableBody = styled.div`
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns: ${gridTemplateColumns};
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
`;

export const TableRow = styled.div`
  display: contents;
  &:hover ${TableData} {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const TooltipChild = styled(Text).attrs({
  color: 'background',
  bg: 'primaryText',
  p: '10px',
  size: 'small',
  wordBreak: 'break-word',
})`
  display: none;
  top: ${TOOLTIP_HEIGHT + TOOLTIP_CHILD_OFFSET}px;
  width: ${({ width }) => width || 'auto'};
  position: absolute;
  border-radius: 5px;
  right: 0;
  box-sizing: content-box;
  line-break: auto;
`;
export const TextIcon = styled(Box).attrs({
  horizontal: true,
  color: 'primaryText',
})`
  display: flex;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'auto')};
`;

export const HeadersText = styled(Text).attrs({
  size: 'small',
  fontWeight: 'bold',
  color: 'primaryText',
  pr: 2,
  ellipsis: true,
})``;
export const CustomToolTip = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  height: `${TOOLTIP_HEIGHT}px`,
  align: 'center',
})`
  &:hover ${TooltipChild} {
    display: flex;
  }
`;

export const DownloadBtn = styled(Button).attrs({
  btnType: 'invisible',
  m: '0',
  px: '0',
  py: '0',
  size: 'xxsmall',
})`
  border: none;
  &:active,
  focus {
    border: none;
  }
`;

export const DownloadItems = styled(DropdownListItem)`
  padding: 7px 8px;
`;
